'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'boxes-stacked';
var width = 512;
var height = 512;
var aliases = [62625,"boxes","boxes-alt"];
var unicode = 'f468';
var svgPathData = 'M336 16c26.5 0 48 21.5 48 48l0 112 16 0 0-112c0-35.3-28.7-64-64-64L176 0c-35.3 0-64 28.7-64 64l0 112 16 0 0-112c0-26.5 21.5-48 48-48l32 0 0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64 32 0zM224 16l64 0 0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm91.9 496L448 512c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64l-132.1 0c3.5 5 6.6 10.4 9.3 16l74.8 0 0 64c0 8.8-7.2 16-16 16l-48 0 0 16 48 0c17.7 0 32-14.3 32-32l0-64 32 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-122.8 0c-2.7 5.6-5.8 11-9.3 16zM240 448.1l0-.1 0-160 0 0 0 160 0 .1zM224 240c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L64 496c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l32 0 0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64 32 0zm-112 0l64 0 0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm112-16L64 224c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxesStacked = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;